import { render, staticRenderFns } from "./ObjectCardBasic.vue?vue&type=template&id=18ece81d&scoped=true&"
import script from "./ObjectCardBasic.vue?vue&type=script&lang=js&"
export * from "./ObjectCardBasic.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardBasic.vue?vue&type=style&index=0&id=18ece81d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ece81d",
  null
  
)

export default component.exports